import { collection, addDoc, query, where, getDocs, orderBy, limit as firestoreLimit } from 'firebase/firestore';
import { db } from '../firebase';

// Save a new quiz attempt
export const saveQuizAttempt = async (attemptData) => {
    try {
        const docRef = await addDoc(collection(db, 'quizAttempts'), {
            ...attemptData,
            timestamp: new Date()
        });
        return docRef.id;
    } catch (error) {
        console.error('Error saving quiz attempt:', error);
        throw error;
    }
};

// Get user's quiz attempts
export const getUserQuizAttempts = async (userId, limitCount = 10) => {
    try {
        const attemptsRef = collection(db, 'quizAttempts');
        const q = query(
            attemptsRef,
            where('userId', '==', userId),
            orderBy('timestamp', 'desc'),
            firestoreLimit(limitCount)
        );
        
        const querySnapshot = await getDocs(q);
        return querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        }));
    } catch (error) {
        console.error('Error fetching quiz attempts:', error);
        throw error;
    }
};

// Get user's statistics
export const getUserStats = async (userId) => {
    try {
        const attempts = await getUserQuizAttempts(userId, 100); // Get last 100 attempts
        
        const stats = {
            quizzesTaken: attempts.length,
            averageScore: 0,
            totalTime: 0,
            subjectsMastered: new Set(),
            recentAttempts: attempts.slice(0, 3)
        };

        if (attempts.length > 0) {
            // Calculate average score
            const totalScore = attempts.reduce((acc, curr) => acc + curr.score, 0);
            stats.averageScore = Math.round(totalScore / attempts.length);

            // Calculate total time
            stats.totalTime = attempts.reduce((acc, curr) => acc + curr.timeSpent, 0);

            // Count mastered subjects (score >= 80%)
            attempts.forEach(attempt => {
                if (attempt.score >= 80) {
                    stats.subjectsMastered.add(attempt.subject);
                }
            });
            stats.subjectsMastered = stats.subjectsMastered.size;
        }

        return stats;
    } catch (error) {
        console.error('Error calculating user stats:', error);
        throw error;
    }
}; 